import React, { useState } from 'react';

export default function Destinations() {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', label: 'All Destinations', icon: '🌍' },
    { id: 'himachal', label: 'Himachal', icon: '🏔️' },
    { id: 'uttarakhand', label: 'Uttarakhand', icon: '⛰️' },
    { id: 'rajasthan', label: 'Rajasthan', icon: '🏰' },
    { id: 'kashmir', label: 'Kashmir', icon: '❄️' },
    { id: 'special', label: 'Special Tours', icon: '✨' }
  ];

  const destinations = [
    {
      id: 1,
      name: 'Shimla - Manali',
      category: 'himachal',
      image: 'https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?w=800&h=600&fit=crop',
      duration: '6N / 7D',
      price: '15,999',
      originalPrice: '18,999',
      rating: 4.8,
      reviews: 245,
      highlights: ['Mall Road', 'Rohtang Pass', 'Solang Valley', 'Hidimba Temple'],
      description: 'Experience the queen of hills with snow-capped mountains and adventure activities',
      badge: 'Best Seller',
      discount: '15% OFF'
    },
    {
      id: 2,
      name: 'Golden Triangle',
      category: 'rajasthan',
      image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=800&h=600&fit=crop',
      duration: '5N / 6D',
      price: '18,999',
      originalPrice: '23,999',
      rating: 4.9,
      reviews: 312,
      highlights: ['Taj Mahal', 'Amber Fort', 'Hawa Mahal', 'Red Fort'],
      description: 'Explore Delhi, Agra, and Jaipur in this iconic cultural journey',
      badge: 'Most Popular',
      discount: '20% OFF'
    },
    {
      id: 3,
      name: 'Leh Ladakh Adventure',
      category: 'kashmir',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&h=600&fit=crop',
      duration: '7N / 8D',
      price: '25,999',
      originalPrice: '28,999',
      rating: 4.9,
      reviews: 189,
      highlights: ['Pangong Lake', 'Nubra Valley', 'Khardung La', 'Magnetic Hill'],
      description: 'Journey through the land of high passes and stunning landscapes',
      badge: 'Adventure',
      discount: '10% OFF'
    },
    {
      id: 4,
      name: 'Jim Corbett National Park',
      category: 'uttarakhand',
      image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&h=600&fit=crop',
      duration: '2N / 3D',
      price: '8,999',
      originalPrice: '10,199',
      rating: 4.7,
      reviews: 156,
      highlights: ['Wildlife Safari', 'Bird Watching', 'Nature Walks', 'River Rafting'],
      description: 'Witness tigers and diverse wildlife in India\'s oldest national park',
      badge: 'Wildlife',
      discount: '12% OFF'
    },
    {
      id: 5,
      name: 'Mussoorie - Rishikesh - Haridwar',
      category: 'uttarakhand',
      image: 'https://images.unsplash.com/photo-1605649487212-47d4628b34c5?w=800&h=600&fit=crop',
      duration: '5N / 6D',
      price: '12,999',
      originalPrice: '15,999',
      rating: 4.8,
      reviews: 198,
      highlights: ['Kempty Falls', 'Laxman Jhula', 'Ganga Aarti', 'River Rafting'],
      description: 'Combine spirituality with adventure in the lap of Himalayas',
      badge: 'Spiritual',
      discount: '18% OFF'
    },
    {
      id: 6,
      name: 'Char Dham Yatra',
      category: 'uttarakhand',
      image: 'https://images.unsplash.com/photo-1585128719214-b74ff0578222?w=800&h=600&fit=crop',
      duration: '12N / 13D',
      price: '35,999',
      originalPrice: '39,099',
      rating: 4.9,
      reviews: 287,
      highlights: ['Yamunotri', 'Gangotri', 'Kedarnath', 'Badrinath'],
      description: 'Complete the sacred pilgrimage to the four holiest Hindu shrines',
      badge: 'Pilgrimage',
      discount: '8% OFF'
    },
    {
      id: 7,
      name: 'Kashmir - Paradise on Earth',
      category: 'kashmir',
      image: 'https://images.unsplash.com/photo-1570544820937-0c6ec92715a6?w=800&h=600&fit=crop',
      duration: '6N / 7D',
      price: '22,999',
      originalPrice: '26,999',
      rating: 4.9,
      reviews: 234,
      highlights: ['Dal Lake', 'Gulmarg', 'Pahalgam', 'Mughal Gardens'],
      description: 'Experience the beauty of Kashmir with houseboats and shikaras',
      badge: 'Romantic',
      discount: '15% OFF'
    },
    {
      id: 8,
      name: 'Jaipur - Udaipur - Jaisalmer',
      category: 'rajasthan',
      image: 'https://images.unsplash.com/photo-1477587458883-47145ed94245?w=800&h=600&fit=crop',
      duration: '8N / 9D',
      price: '24,999',
      originalPrice: '28,399',
      rating: 4.8,
      reviews: 176,
      highlights: ['City Palace', 'Lake Pichola', 'Thar Desert', 'Camel Safari'],
      description: 'Discover the royal heritage and desert landscapes of Rajasthan',
      badge: 'Heritage',
      discount: '12% OFF'
    },
    {
      id: 9,
      name: 'Dharamshala - Dalhousie',
      category: 'himachal',
      image: 'https://images.unsplash.com/photo-1587974928442-77dc3e0dba72?w=800&h=600&fit=crop',
      duration: '5N / 6D',
      price: '13,999',
      originalPrice: '15,554',
      rating: 4.7,
      reviews: 142,
      highlights: ['McLeod Ganj', 'Khajjiar', 'Dalai Lama Temple', 'Kalatop Wildlife'],
      description: 'Explore Tibetan culture and scenic hill stations',
      badge: 'Culture',
      discount: '10% OFF'
    },
    {
      id: 10,
      name: 'Taj Mahal Day Tour',
      category: 'special',
      image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=800&h=600&fit=crop',
      duration: '1 Day',
      price: '3,999',
      originalPrice: '4,209',
      rating: 4.8,
      reviews: 421,
      highlights: ['Taj Mahal', 'Agra Fort', 'Mehtab Bagh', 'Local Cuisine'],
      description: 'Same day return tour to the symbol of eternal love',
      badge: 'Quick Trip',
      discount: '5% OFF'
    },
    {
      id: 11,
      name: 'Honeymoon Special - Shimla',
      category: 'special',
      image: 'https://images.unsplash.com/photo-1519904981063-b0cf448d479e?w=800&h=600&fit=crop',
      duration: '4N / 5D',
      price: '19,999',
      originalPrice: '24,999',
      rating: 4.9,
      reviews: 298,
      highlights: ['Candlelight Dinner', 'Couple Spa', 'Private Tours', 'Decorated Room'],
      description: 'Romantic getaway with special couple activities and amenities',
      badge: 'Honeymoon',
      discount: '20% OFF'
    },
    {
      id: 12,
      name: 'Kufri Snow Adventure',
      category: 'himachal',
      image: 'https://images.unsplash.com/photo-1551582045-6ec9c11d8697?w=800&h=600&fit=crop',
      duration: '3N / 4D',
      price: '11,999',
      originalPrice: '14,116',
      rating: 4.7,
      reviews: 167,
      highlights: ['Snow Activities', 'Skiing', 'Himalayan Nature Park', 'Horse Riding'],
      description: 'Winter wonderland with exciting snow sports and activities',
      badge: 'Winter Special',
      discount: '15% OFF'
    }
  ];

  const filteredDestinations = activeCategory === 'all' 
    ? destinations 
    : destinations.filter(dest => dest.category === activeCategory);

  return (
    <section
      id="destinations"
      className="py-16 sm:py-20 px-4 sm:px-6 md:px-16 bg-gradient-to-br from-sky-50 via-blue-50 to-cyan-50 relative overflow-hidden"
    >
      {/* Animated Background */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-sky-300/40 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-300/30 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
      <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-blue-200/25 rounded-full blur-3xl animate-pulse" style={{animationDelay: '2s'}}></div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-sky-500 via-blue-600 to-cyan-500 drop-shadow-lg mb-4 animate-pulse">
            Featured Destinations
          </h2>
          <p className="text-base sm:text-lg max-w-2xl mx-auto text-gray-600">
            Explore India's most breathtaking destinations with our carefully curated tour packages
          </p>
          <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-sky-500 to-cyan-500 mx-auto rounded-full mt-4"></div>
        </div>

        {/* Category Filters */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`px-6 py-2.5 rounded-full font-semibold text-sm transition-all duration-300 ${
                activeCategory === category.id
                  ? 'bg-gradient-to-r from-sky-500 to-cyan-500 text-white shadow-lg shadow-sky-400/50 scale-105'
                  : 'bg-white/70 backdrop-blur-sm text-gray-700 hover:bg-white/90 border border-sky-300 shadow-md'
              }`}
            >
              <span className="mr-2">{category.icon}</span>
              {category.label}
            </button>
          ))}
        </div>

        {/* Destinations Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {filteredDestinations.map((destination, index) => (
            <div
              key={destination.id}
              className="bg-white/70 backdrop-blur-sm rounded-2xl shadow-lg border border-sky-200 overflow-hidden hover:shadow-2xl hover:shadow-sky-300/50 hover:-translate-y-2 transition-all duration-300 group"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Image */}
              <div className="relative overflow-hidden h-48 sm:h-56">
                <img
                  src={destination.image}
                  alt={destination.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                {/* Badge */}
                <div className="absolute top-3 left-3 bg-gradient-to-r from-sky-500 to-blue-600 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                  {destination.badge}
                </div>
                {/* Discount */}
                <div className="absolute top-3 right-3 bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                  {destination.discount}
                </div>
              </div>

              {/* Content */}
              <div className="p-5 sm:p-6">
                {/* Title & Rating */}
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-xl font-bold text-gray-900 group-hover:text-sky-600 transition-colors">
                    {destination.name}
                  </h3>
                  <div className="flex items-center gap-1 bg-sky-100 px-2 py-1 rounded-lg border border-sky-300">
                    <svg className="w-4 h-4 text-cyan-600" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                    <span className="text-xs font-semibold text-gray-700">{destination.rating}</span>
                  </div>
                </div>

                {/* Duration & Description */}
                <div className="space-y-2 mb-4">
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <svg className="w-4 h-4 text-sky-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <span className="font-medium">{destination.duration}</span>
                  </div>
                  <p className="text-sm text-gray-600 line-clamp-2">
                    {destination.description}
                  </p>
                </div>

                {/* Highlights */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {destination.highlights.slice(0, 3).map((highlight, i) => (
                    <span
                      key={i}
                      className="px-3 py-1 bg-sky-100 text-sky-700 rounded-full text-xs font-medium border border-sky-300"
                    >
                      {highlight}
                    </span>
                  ))}
                  {destination.highlights.length > 3 && (
                    <span className="px-3 py-1 bg-cyan-100 text-cyan-700 rounded-full text-xs font-medium border border-cyan-300">
                      +{destination.highlights.length - 3}
                    </span>
                  )}
                </div>

                {/* Price & CTA */}
                <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                  <div>
                    <div className="flex items-baseline gap-2">
                      <span className="text-2xl font-bold text-sky-600">₹{destination.price}</span>
                      <span className="text-sm text-gray-500 line-through">₹{destination.originalPrice}</span>
                    </div>
                    <p className="text-xs text-gray-500">Per Person</p>
                  </div>
                  <a
                    href={`https://wa.me/918929550611?text=Hi! I'm interested in ${destination.name}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-5 py-2.5 bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-semibold rounded-full shadow-md hover:shadow-lg hover:shadow-cyan-400/50 hover:scale-105 transition-all duration-300 text-sm"
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 sm:mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-sky-400 via-blue-500 to-cyan-400 p-1 rounded-2xl shadow-2xl shadow-sky-400/30">
            <div className="bg-white px-8 py-6 rounded-2xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Need a Custom Itinerary?
              </h3>
              <p className="text-gray-600 mb-4">
                Let us create a personalized travel plan just for you!
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <a
                  href="https://wa.me/918929550611"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-bold rounded-full shadow-lg hover:shadow-cyan-400/50 hover:scale-105 transition-all duration-200"
                >
                  📱 WhatsApp Us
                </a>
                <a
                  href="tel:+918929550611"
                  className="px-6 py-3 bg-gradient-to-r from-sky-500 to-blue-600 text-white font-bold rounded-full shadow-lg hover:shadow-sky-400/50 hover:scale-105 transition-all duration-200"
                >
                  📞 Call Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// import React, { useState } from 'react';

// export default function Destinations() {
//   const [activeCategory, setActiveCategory] = useState('all');

//   const categories = [
//     { id: 'all', label: 'All Destinations', icon: '🌍' },
//     { id: 'himachal', label: 'Himachal', icon: '🏔️' },
//     { id: 'uttarakhand', label: 'Uttarakhand', icon: '⛰️' },
//     { id: 'rajasthan', label: 'Rajasthan', icon: '🏰' },
//     { id: 'kashmir', label: 'Kashmir', icon: '❄️' },
//     { id: 'special', label: 'Special Tours', icon: '✨' }
//   ];

//   const destinations = [
//     {
//       id: 1,
//       name: 'Shimla - Manali',
//       category: 'himachal',
//       image: 'https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?w=800&h=600&fit=crop',
//       duration: '6N / 7D',
//       price: '15,999',
//       originalPrice: '18,999',
//       rating: 4.8,
//       reviews: 245,
//       highlights: ['Mall Road', 'Rohtang Pass', 'Solang Valley', 'Hidimba Temple'],
//       description: 'Experience the queen of hills with snow-capped mountains and adventure activities',
//       badge: 'Best Seller',
//       discount: '15% OFF'
//     },
//     {
//       id: 2,
//       name: 'Golden Triangle',
//       category: 'rajasthan',
//       image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=800&h=600&fit=crop',
//       duration: '5N / 6D',
//       price: '18,999',
//       originalPrice: '23,999',
//       rating: 4.9,
//       reviews: 312,
//       highlights: ['Taj Mahal', 'Amber Fort', 'Hawa Mahal', 'Red Fort'],
//       description: 'Explore Delhi, Agra, and Jaipur in this iconic cultural journey',
//       badge: 'Most Popular',
//       discount: '20% OFF'
//     },
//     {
//       id: 3,
//       name: 'Leh Ladakh Adventure',
//       category: 'kashmir',
//       image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&h=600&fit=crop',
//       duration: '7N / 8D',
//       price: '25,999',
//       originalPrice: '28,999',
//       rating: 4.9,
//       reviews: 189,
//       highlights: ['Pangong Lake', 'Nubra Valley', 'Khardung La', 'Magnetic Hill'],
//       description: 'Journey through the land of high passes and stunning landscapes',
//       badge: 'Adventure',
//       discount: '10% OFF'
//     },
//     {
//       id: 4,
//       name: 'Jim Corbett National Park',
//       category: 'uttarakhand',
//       image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&h=600&fit=crop',
//       duration: '2N / 3D',
//       price: '8,999',
//       originalPrice: '10,199',
//       rating: 4.7,
//       reviews: 156,
//       highlights: ['Wildlife Safari', 'Bird Watching', 'Nature Walks', 'River Rafting'],
//       description: 'Witness tigers and diverse wildlife in India\'s oldest national park',
//       badge: 'Wildlife',
//       discount: '12% OFF'
//     },
//     {
//       id: 5,
//       name: 'Mussoorie - Rishikesh - Haridwar',
//       category: 'uttarakhand',
//       image: 'https://images.unsplash.com/photo-1605649487212-47d4628b34c5?w=800&h=600&fit=crop',
//       duration: '5N / 6D',
//       price: '12,999',
//       originalPrice: '15,999',
//       rating: 4.8,
//       reviews: 198,
//       highlights: ['Kempty Falls', 'Laxman Jhula', 'Ganga Aarti', 'River Rafting'],
//       description: 'Combine spirituality with adventure in the lap of Himalayas',
//       badge: 'Spiritual',
//       discount: '18% OFF'
//     },
//     {
//       id: 6,
//       name: 'Char Dham Yatra',
//       category: 'uttarakhand',
//       image: 'https://images.unsplash.com/photo-1585128719214-b74ff0578222?w=800&h=600&fit=crop',
//       duration: '12N / 13D',
//       price: '35,999',
//       originalPrice: '39,099',
//       rating: 4.9,
//       reviews: 287,
//       highlights: ['Yamunotri', 'Gangotri', 'Kedarnath', 'Badrinath'],
//       description: 'Complete the sacred pilgrimage to the four holiest Hindu shrines',
//       badge: 'Pilgrimage',
//       discount: '8% OFF'
//     },
//     {
//       id: 7,
//       name: 'Kashmir - Paradise on Earth',
//       category: 'kashmir',
//       image: 'https://images.unsplash.com/photo-1570544820937-0c6ec92715a6?w=800&h=600&fit=crop',
//       duration: '6N / 7D',
//       price: '22,999',
//       originalPrice: '26,999',
//       rating: 4.9,
//       reviews: 234,
//       highlights: ['Dal Lake', 'Gulmarg', 'Pahalgam', 'Mughal Gardens'],
//       description: 'Experience the beauty of Kashmir with houseboats and shikaras',
//       badge: 'Romantic',
//       discount: '15% OFF'
//     },
//     {
//       id: 8,
//       name: 'Jaipur - Udaipur - Jaisalmer',
//       category: 'rajasthan',
//       image: 'https://images.unsplash.com/photo-1477587458883-47145ed94245?w=800&h=600&fit=crop',
//       duration: '8N / 9D',
//       price: '24,999',
//       originalPrice: '28,399',
//       rating: 4.8,
//       reviews: 176,
//       highlights: ['City Palace', 'Lake Pichola', 'Thar Desert', 'Camel Safari'],
//       description: 'Discover the royal heritage and desert landscapes of Rajasthan',
//       badge: 'Heritage',
//       discount: '12% OFF'
//     },
//     {
//       id: 9,
//       name: 'Dharamshala - Dalhousie',
//       category: 'himachal',
//       image: 'https://images.unsplash.com/photo-1587974928442-77dc3e0dba72?w=800&h=600&fit=crop',
//       duration: '5N / 6D',
//       price: '13,999',
//       originalPrice: '15,554',
//       rating: 4.7,
//       reviews: 142,
//       highlights: ['McLeod Ganj', 'Khajjiar', 'Dalai Lama Temple', 'Kalatop Wildlife'],
//       description: 'Explore Tibetan culture and scenic hill stations',
//       badge: 'Culture',
//       discount: '10% OFF'
//     },
//     {
//       id: 10,
//       name: 'Taj Mahal Day Tour',
//       category: 'special',
//       image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=800&h=600&fit=crop',
//       duration: '1 Day',
//       price: '3,999',
//       originalPrice: '4,209',
//       rating: 4.8,
//       reviews: 421,
//       highlights: ['Taj Mahal', 'Agra Fort', 'Mehtab Bagh', 'Local Cuisine'],
//       description: 'Same day return tour to the symbol of eternal love',
//       badge: 'Quick Trip',
//       discount: '5% OFF'
//     },
//     {
//       id: 11,
//       name: 'Honeymoon Special - Shimla',
//       category: 'special',
//       image: 'https://images.unsplash.com/photo-1519904981063-b0cf448d479e?w=800&h=600&fit=crop',
//       duration: '4N / 5D',
//       price: '19,999',
//       originalPrice: '24,999',
//       rating: 4.9,
//       reviews: 298,
//       highlights: ['Candlelight Dinner', 'Couple Spa', 'Private Tours', 'Decorated Room'],
//       description: 'Romantic getaway with special couple activities and amenities',
//       badge: 'Honeymoon',
//       discount: '20% OFF'
//     },
//     {
//       id: 12,
//       name: 'Kufri Snow Adventure',
//       category: 'himachal',
//       image: 'https://images.unsplash.com/photo-1551582045-6ec9c11d8697?w=800&h=600&fit=crop',
//       duration: '3N / 4D',
//       price: '11,999',
//       originalPrice: '14,116',
//       rating: 4.7,
//       reviews: 167,
//       highlights: ['Snow Activities', 'Skiing', 'Himalayan Nature Park', 'Horse Riding'],
//       description: 'Winter wonderland with exciting snow sports and activities',
//       badge: 'Winter Special',
//       discount: '15% OFF'
//     }
//   ];

//   const filteredDestinations = activeCategory === 'all' 
//     ? destinations 
//     : destinations.filter(dest => dest.category === activeCategory);

//   return (
//     <section
//       id="destinations"
//       className="py-16 sm:py-20 px-4 sm:px-6 md:px-16 bg-gradient-to-br from-gray-900 via-blue-950 to-gray-900 relative overflow-hidden"
//     >
//       {/* Animated Background */}
//       <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
//       <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>

//       <div className="max-w-7xl mx-auto relative z-10">
//         {/* Section Header */}
//         <div className="text-center mb-12 sm:mb-16">
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-blue-300 to-orange-400 drop-shadow mb-4">
//             Featured Destinations
//           </h2>
//           <p className="text-base sm:text-lg max-w-2xl mx-auto text-gray-300">
//             Explore India's most breathtaking destinations with our carefully curated tour packages
//           </p>
//           <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-blue-500 to-orange-500 mx-auto rounded-full mt-4"></div>
//         </div>

//         {/* Category Filters */}
//         <div className="flex flex-wrap justify-center gap-3 mb-12">
//           {categories.map((category) => (
//             <button
//               key={category.id}
//               onClick={() => setActiveCategory(category.id)}
//               className={`px-6 py-2.5 rounded-full font-semibold text-sm transition-all duration-300 ${
//                 activeCategory === category.id
//                   ? 'bg-gradient-to-r from-blue-500 to-orange-500 text-white shadow-lg shadow-blue-500/50 scale-105'
//                   : 'bg-gray-800/50 backdrop-blur-sm text-gray-300 hover:bg-gray-700/50 border border-blue-500/20 shadow-md'
//               }`}
//             >
//               <span className="mr-2">{category.icon}</span>
//               {category.label}
//             </button>
//           ))}
//         </div>

//         {/* Destinations Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
//           {filteredDestinations.map((destination, index) => (
//             <div
//               key={destination.id}
//               className="bg-gray-800/50 backdrop-blur-sm rounded-2xl shadow-lg border border-blue-500/20 overflow-hidden hover:shadow-2xl hover:shadow-blue-500/20 hover:-translate-y-2 transition-all duration-300 group"
//               style={{ animationDelay: `${index * 0.1}s` }}
//             >
//               {/* Image */}
//               <div className="relative overflow-hidden h-48 sm:h-56">
//                 <img
//                   src={destination.image}
//                   alt={destination.name}
//                   className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//                 />
//                 {/* Badge */}
//                 <div className="absolute top-3 left-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
//                   {destination.badge}
//                 </div>
//                 {/* Discount */}
//                 <div className="absolute top-3 right-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
//                   {destination.discount}
//                 </div>
//               </div>

//               {/* Content */}
//               <div className="p-5 sm:p-6">
//                 {/* Title & Rating */}
//                 <div className="flex items-start justify-between mb-3">
//                   <h3 className="text-xl font-bold text-white group-hover:text-blue-400 transition-colors">
//                     {destination.name}
//                   </h3>
//                   <div className="flex items-center gap-1 bg-blue-500/20 px-2 py-1 rounded-lg border border-blue-400/30">
//                     <svg className="w-4 h-4 text-orange-400" fill="currentColor" viewBox="0 0 20 20">
//                       <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                     </svg>
//                     <span className="text-xs font-semibold text-gray-200">{destination.rating}</span>
//                   </div>
//                 </div>

//                 {/* Duration & Description */}
//                 <div className="space-y-2 mb-4">
//                   <div className="flex items-center gap-2 text-sm text-gray-300">
//                     <svg className="w-4 h-4 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//                     </svg>
//                     <span className="font-medium">{destination.duration}</span>
//                   </div>
//                   <p className="text-sm text-gray-400 line-clamp-2">
//                     {destination.description}
//                   </p>
//                 </div>

//                 {/* Highlights */}
//                 <div className="flex flex-wrap gap-2 mb-4">
//                   {destination.highlights.slice(0, 3).map((highlight, i) => (
//                     <span
//                       key={i}
//                       className="px-3 py-1 bg-blue-500/20 text-blue-300 rounded-full text-xs font-medium border border-blue-400/30"
//                     >
//                       {highlight}
//                     </span>
//                   ))}
//                   {destination.highlights.length > 3 && (
//                     <span className="px-3 py-1 bg-orange-500/20 text-orange-300 rounded-full text-xs font-medium border border-orange-400/30">
//                       +{destination.highlights.length - 3}
//                     </span>
//                   )}
//                 </div>

//                 {/* Price & CTA */}
//                 <div className="flex items-center justify-between pt-4 border-t border-gray-700">
//                   <div>
//                     <div className="flex items-baseline gap-2">
//                       <span className="text-2xl font-bold text-blue-400">₹{destination.price}</span>
//                       <span className="text-sm text-gray-500 line-through">₹{destination.originalPrice}</span>
//                     </div>
//                     <p className="text-xs text-gray-400">Per Person</p>
//                   </div>
//                   <a
//                     href={`https://wa.me/918929550611?text=Hi! I'm interested in ${destination.name}`}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="px-5 py-2.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-full shadow-md hover:shadow-lg hover:shadow-orange-500/50 hover:scale-105 transition-all duration-300 text-sm"
//                   >
//                     Book Now
//                   </a>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Bottom CTA */}
//         <div className="mt-12 sm:mt-16 text-center">
//           <div className="inline-block bg-gradient-to-r from-blue-500 via-blue-400 to-orange-500 p-1 rounded-2xl shadow-2xl shadow-blue-500/30">
//             <div className="bg-gray-900 px-8 py-6 rounded-2xl">
//               <h3 className="text-2xl font-bold text-white mb-2">
//                 Need a Custom Itinerary?
//               </h3>
//               <p className="text-gray-300 mb-4">
//                 Let us create a personalized travel plan just for you!
//               </p>
//               <div className="flex flex-col sm:flex-row gap-3 justify-center">
//                 <a
//                   href="https://wa.me/918929550611"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold rounded-full shadow-lg hover:shadow-orange-500/50 hover:scale-105 transition-all duration-200"
//                 >
//                   📱 WhatsApp Us
//                 </a>
//                 <a
//                   href="tel:+918929550611"
//                   className="px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold rounded-full shadow-lg hover:shadow-blue-500/50 hover:scale-105 transition-all duration-200"
//                 >
//                   📞 Call Now
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// import React, { useState } from 'react';

// export default function Destinations() {
//   const [activeCategory, setActiveCategory] = useState('all');

//   const categories = [
//     { id: 'all', label: 'All Destinations', icon: '🌍' },
//     { id: 'himachal', label: 'Himachal', icon: '🏔️' },
//     { id: 'uttarakhand', label: 'Uttarakhand', icon: '⛰️' },
//     { id: 'rajasthan', label: 'Rajasthan', icon: '🏰' },
//     { id: 'kashmir', label: 'Kashmir', icon: '❄️' },
//     { id: 'special', label: 'Special Tours', icon: '✨' }
//   ];

//   const destinations = [
//     {
//       id: 1,
//       name: 'Shimla - Manali',
//       category: 'himachal',
//       image: 'https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?w=800&h=600&fit=crop',
//       duration: '6N / 7D',
//       price: '15,999',
//       rating: 4.8,
//       reviews: 245,
//       highlights: ['Mall Road', 'Rohtang Pass', 'Solang Valley', 'Hidimba Temple'],
//       description: 'Experience the queen of hills with snow-capped mountains and adventure activities',
//       badge: 'Best Seller',
//       discount: '15%'
//     },
//     {
//       id: 2,
//       name: 'Golden Triangle',
//       category: 'rajasthan',
//       image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=800&h=600&fit=crop',
//       duration: '5N / 6D',
//       price: '18,999',
//       rating: 4.9,
//       reviews: 312,
//       highlights: ['Taj Mahal', 'Amber Fort', 'Hawa Mahal', 'Red Fort'],
//       description: 'Explore Delhi, Agra, and Jaipur in this iconic cultural journey',
//       badge: 'Most Popular',
//       discount: '20%'
//     },
//     {
//       id: 3,
//       name: 'Leh Ladakh Adventure',
//       category: 'kashmir',
//       image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&h=600&fit=crop',
//       duration: '7N / 8D',
//       price: '25,999',
//       rating: 4.9,
//       reviews: 189,
//       highlights: ['Pangong Lake', 'Nubra Valley', 'Khardung La', 'Magnetic Hill'],
//       description: 'Journey through the land of high passes and stunning landscapes',
//       badge: 'Adventure',
//       discount: '10%'
//     },
//     {
//       id: 4,
//       name: 'Jim Corbett National Park',
//       category: 'uttarakhand',
//       image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&h=600&fit=crop',
//       duration: '2N / 3D',
//       price: '8,999',
//       rating: 4.7,
//       reviews: 156,
//       highlights: ['Wildlife Safari', 'Bird Watching', 'Nature Walks', 'River Rafting'],
//       description: 'Witness tigers and diverse wildlife in India\'s oldest national park',
//       badge: 'Wildlife',
//       discount: '12%'
//     },
//     {
//       id: 5,
//       name: 'Mussoorie - Rishikesh - Haridwar',
//       category: 'uttarakhand',
//       image: 'https://images.unsplash.com/photo-1605649487212-47d4628b34c5?w=800&h=600&fit=crop',
//       duration: '5N / 6D',
//       price: '12,999',
//       rating: 4.8,
//       reviews: 198,
//       highlights: ['Kempty Falls', 'Laxman Jhula', 'Ganga Aarti', 'River Rafting'],
//       description: 'Combine spirituality with adventure in the lap of Himalayas',
//       badge: 'Spiritual',
//       discount: '18%'
//     },
//     {
//       id: 6,
//       name: 'Char Dham Yatra',
//       category: 'uttarakhand',
//       image: 'https://images.unsplash.com/photo-1585128719214-b74ff0578222?w=800&h=600&fit=crop',
//       duration: '12N / 13D',
//       price: '35,999',
//       rating: 4.9,
//       reviews: 287,
//       highlights: ['Yamunotri', 'Gangotri', 'Kedarnath', 'Badrinath'],
//       description: 'Complete the sacred pilgrimage to the four holiest Hindu shrines',
//       badge: 'Pilgrimage',
//       discount: '8%'
//     },
//     {
//       id: 7,
//       name: 'Kashmir - Paradise on Earth',
//       category: 'kashmir',
//       image: 'https://images.unsplash.com/photo-1570544820937-0c6ec92715a6?w=800&h=600&fit=crop',
//       duration: '6N / 7D',
//       price: '22,999',
//       rating: 4.9,
//       reviews: 234,
//       highlights: ['Dal Lake', 'Gulmarg', 'Pahalgam', 'Mughal Gardens'],
//       description: 'Experience the beauty of Kashmir with houseboats and shikaras',
//       badge: 'Romantic',
//       discount: '15%'
//     },
//     {
//       id: 8,
//       name: 'Jaipur - Udaipur - Jaisalmer',
//       category: 'rajasthan',
//       image: 'https://images.unsplash.com/photo-1477587458883-47145ed94245?w=800&h=600&fit=crop',
//       duration: '8N / 9D',
//       price: '24,999',
//       rating: 4.8,
//       reviews: 176,
//       highlights: ['City Palace', 'Lake Pichola', 'Thar Desert', 'Camel Safari'],
//       description: 'Discover the royal heritage and desert landscapes of Rajasthan',
//       badge: 'Heritage',
//       discount: '12%'
//     },
//     {
//       id: 9,
//       name: 'Dharamshala - Dalhousie',
//       category: 'himachal',
//       image: 'https://images.unsplash.com/photo-1587974928442-77dc3e0dba72?w=800&h=600&fit=crop',
//       duration: '5N / 6D',
//       price: '13,999',
//       rating: 4.7,
//       reviews: 142,
//       highlights: ['McLeod Ganj', 'Khajjiar', 'Dalai Lama Temple', 'Kalatop Wildlife'],
//       description: 'Explore Tibetan culture and scenic hill stations',
//       badge: 'Culture',
//       discount: '10%'
//     },
//     {
//       id: 10,
//       name: 'Taj Mahal Day Tour',
//       category: 'special',
//       image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=800&h=600&fit=crop',
//       duration: '1 Day',
//       price: '3,999',
//       rating: 4.8,
//       reviews: 421,
//       highlights: ['Taj Mahal', 'Agra Fort', 'Mehtab Bagh', 'Local Cuisine'],
//       description: 'Same day return tour to the symbol of eternal love',
//       badge: 'Quick Trip',
//       discount: '5%'
//     },
//     {
//       id: 11,
//       name: 'Honeymoon Special - Shimla',
//       category: 'special',
//       image: 'https://images.unsplash.com/photo-1519904981063-b0cf448d479e?w=800&h=600&fit=crop',
//       duration: '4N / 5D',
//       price: '19,999',
//       rating: 4.9,
//       reviews: 298,
//       highlights: ['Candlelight Dinner', 'Couple Spa', 'Private Tours', 'Decorated Room'],
//       description: 'Romantic getaway with special couple activities and amenities',
//       badge: 'Honeymoon',
//       discount: '20%'
//     },
//     {
//       id: 12,
//       name: 'Kufri Snow Adventure',
//       category: 'himachal',
//       image: 'https://images.unsplash.com/photo-1551582045-6ec9c11d8697?w=800&h=600&fit=crop',
//       duration: '3N / 4D',
//       price: '11,999',
//       rating: 4.7,
//       reviews: 167,
//       highlights: ['Snow Activities', 'Skiing', 'Himalayan Nature Park', 'Horse Riding'],
//       description: 'Winter wonderland with exciting snow sports and activities',
//       badge: 'Winter Special',
//       discount: '15%'
//     }
//   ];

//   const filteredDestinations = activeCategory === 'all' 
//     ? destinations 
//     : destinations.filter(dest => dest.category === activeCategory);

//   return (
//     <section
//       id="destinations"
//       className="py-16 sm:py-20 px-4 sm:px-6 md:px-16 bg-gradient-to-br from-purple-50 via-white to-blue-50"
//     >
//       <div className="max-w-7xl mx-auto">
//         {/* Section Header */}
//         <div className="text-center mb-12 sm:mb-16">
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-600 to-blue-500 drop-shadow mb-4">
//             Featured Destinations
//           </h2>
//           <p className="text-base sm:text-lg max-w-2xl mx-auto text-gray-700">
//             Explore India's most breathtaking destinations with our carefully curated tour packages
//           </p>
//           <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-purple-500 to-blue-500 mx-auto rounded-full mt-4"></div>
//         </div>

//         {/* Category Filters */}
//         <div className="flex flex-wrap justify-center gap-3 mb-12">
//           {categories.map((category) => (
//             <button
//               key={category.id}
//               onClick={() => setActiveCategory(category.id)}
//               className={`px-5 py-2.5 rounded-full font-semibold text-sm transition-all duration-300 ${
//                 activeCategory === category.id
//                   ? 'bg-gradient-to-r from-purple-500 to-blue-500 text-white shadow-lg scale-105'
//                   : 'bg-white text-gray-700 hover:bg-gray-100 shadow-md'
//               }`}
//             >
//               <span className="mr-2">{category.icon}</span>
//               {category.label}
//             </button>
//           ))}
//         </div>

//         {/* Destinations Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
//           {filteredDestinations.map((destination, index) => (
//             <div
//               key={destination.id}
//               className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 group"
//               style={{ animationDelay: `${index * 0.1}s` }}
//             >
//               {/* Image */}
//               <div className="relative overflow-hidden h-56 sm:h-64">
//                 <img
//                   src={destination.image}
//                   alt={destination.name}
//                   className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//                 />
//                 {/* Badge */}
//                 {destination.badge && (
//                   <div className="absolute top-3 left-3 bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
//                     {destination.badge}
//                   </div>
//                 )}
//                 {/* Discount */}
//                 {destination.discount && (
//                   <div className="absolute top-3 right-3 bg-red-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
//                     {destination.discount} OFF
//                   </div>
//                 )}
//                 {/* Duration */}
//                 <div className="absolute bottom-3 left-3 bg-black/70 backdrop-blur-sm text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center gap-1">
//                   <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
//                   </svg>
//                   {destination.duration}
//                 </div>
//               </div>

//               {/* Content */}
//               <div className="p-5 sm:p-6">
//                 {/* Destination Name */}
//                 <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-purple-600 transition-colors">
//                   {destination.name}
//                 </h3>

//                 {/* Rating */}
//                 <div className="flex items-center gap-2 mb-3">
//                   <div className="flex items-center gap-1">
//                     {[...Array(5)].map((_, i) => (
//                       <svg
//                         key={i}
//                         className={`w-4 h-4 ${
//                           i < Math.floor(destination.rating)
//                             ? 'text-yellow-400'
//                             : 'text-gray-300'
//                         }`}
//                         fill="currentColor"
//                         viewBox="0 0 20 20"
//                       >
//                         <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                       </svg>
//                     ))}
//                   </div>
//                   <span className="text-sm text-gray-600 font-medium">
//                     {destination.rating} ({destination.reviews} reviews)
//                   </span>
//                 </div>

//                 {/* Description */}
//                 <p className="text-sm text-gray-600 mb-4 line-clamp-2">
//                   {destination.description}
//                 </p>

//                 {/* Highlights */}
//                 <div className="mb-4">
//                   <p className="text-xs font-semibold text-gray-700 mb-2">Tour Highlights:</p>
//                   <div className="flex flex-wrap gap-2">
//                     {destination.highlights.slice(0, 3).map((highlight, i) => (
//                       <span
//                         key={i}
//                         className="px-2 py-1 bg-purple-50 text-purple-700 rounded-md text-xs font-medium flex items-center gap-1"
//                       >
//                         <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
//                           <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//                         </svg>
//                         {highlight}
//                       </span>
//                     ))}
//                     {destination.highlights.length > 3 && (
//                       <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded-md text-xs font-medium">
//                         +{destination.highlights.length - 3} more
//                       </span>
//                     )}
//                   </div>
//                 </div>

//                 {/* Pricing */}
//                 <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-xl p-4 mb-4">
//                   <div className="flex items-center justify-between">
//                     <div>
//                       <p className="text-xs text-gray-600 mb-1">Starting from</p>
//                       <p className="text-3xl font-bold text-purple-600">₹{destination.price}</p>
//                       <p className="text-xs text-gray-500">per person</p>
//                     </div>
//                     <div className="text-right">
//                       <div className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-bold mb-1">
//                         Save {destination.discount}
//                       </div>
//                       <p className="text-xs text-gray-500">Limited offer</p>
//                     </div>
//                   </div>
//                 </div>

//                 {/* CTA Buttons */}
//                 <div className="grid grid-cols-2 gap-3">
//                   <a
//                     href={`https://wa.me/917027005176?text=Hi! I want to book ${destination.name} tour package`}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="px-4 py-2.5 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold rounded-lg shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300 text-sm text-center flex items-center justify-center gap-1"
//                   >
//                     <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
//                       <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//                     </svg>
//                     Book Now
//                   </a>
//                   <button className="px-4 py-2.5 bg-white border-2 border-purple-500 text-purple-600 font-semibold rounded-lg hover:bg-purple-50 transition-all duration-300 text-sm">
//                     View Details
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Why Choose Us Section */}
//         <div className="mt-16 bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 rounded-2xl p-8 text-white shadow-xl">
//           <div className="text-center mb-8">
//             <h3 className="text-2xl sm:text-3xl font-bold mb-2">Why Choose Dream To Travels?</h3>
//             <p className="text-white/90">Your trusted partner for unforgettable journeys across India</p>
//           </div>
          
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//             {[
//               { icon: '💰', title: 'Best Price Guarantee', desc: 'Competitive rates with no hidden charges' },
//               { icon: '🎯', title: 'Handpicked Deals', desc: 'Carefully selected destinations and hotels' },
//               { icon: '🛡️', title: 'Secure Booking', desc: 'Safe and encrypted payment process' },
//               { icon: '🤝', title: 'Passionate Service', desc: '24/7 customer support for your needs' }
//             ].map((item, i) => (
//               <div key={i} className="text-center">
//                 <div className="text-4xl mb-3">{item.icon}</div>
//                 <h4 className="font-bold text-lg mb-1">{item.title}</h4>
//                 <p className="text-sm text-white/80">{item.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Special Offer Banner */}
//         <div className="mt-12 text-center">
//           <div className="inline-block bg-white p-8 rounded-2xl shadow-xl max-w-2xl">
//             <div className="text-5xl mb-4">🎉</div>
//             <h3 className="text-2xl font-bold text-gray-800 mb-3">
//               Get 15% Off Your First Trip!
//             </h3>
//             <p className="text-gray-600 mb-6">
//               Book your dream vacation now and take advantage of our special first-time customer discount
//             </p>
//             <div className="flex flex-col sm:flex-row gap-3 justify-center">
//               <a
//                 href="tel:+917027005176"
//                 className="px-8 py-3 bg-gradient-to-r from-purple-500 to-blue-500 text-white font-bold rounded-full shadow-lg hover:scale-105 transition-transform duration-200 flex items-center justify-center gap-2"
//               >
//                 <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                   <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
//                 </svg>
//                 Call: +91-7027005176
//               </a>
//               <a
//                 href="https://wa.me/917027005176?text=Hi! I want to know more about the 15% discount offer"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="px-8 py-3 bg-gradient-to-r from-green-500 to-green-600 text-white font-bold rounded-full shadow-lg hover:scale-105 transition-transform duration-200 flex items-center justify-center gap-2"
//               >
//                 <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                   <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//                 </svg>
//                 Chat on WhatsApp
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }